import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment.development';
import {
  CreateTemplateResponseData,
  ListTemplateResponseData,
  ReadTemplateResponseData,
  TemplateRequestData,
} from './template.model';

@Injectable({ providedIn: 'root' })
export class TemplateService {
  private apiUrl = `${environment.apiUrl}/template`;

  constructor(private http: HttpClient) {}

  createTemplate(
    data: TemplateRequestData
  ): Observable<CreateTemplateResponseData> {
    return this.http.post<CreateTemplateResponseData>(`${this.apiUrl}`, data);
  }

  searchTemplate(search: string): Observable<ListTemplateResponseData> {
    return this.http.get<ListTemplateResponseData>(
      `${this.apiUrl}?search=${search}`
    );
  }

  fetchAllTemplates(): Observable<ListTemplateResponseData> {
    return this.http.get<ListTemplateResponseData>(`${this.apiUrl}`);
  }

  fetchTemplate(id: string): Observable<ReadTemplateResponseData> {
    return this.http.get<ReadTemplateResponseData>(`${this.apiUrl}/${id}`);
  }

  duplicateTemplate(
    template_id: string,
    name?: string
  ): Observable<CreateTemplateResponseData> { 
    return this.http.post<CreateTemplateResponseData>(
      `${this.apiUrl}/duplicate`,
      { template_id, name } 
    );
  }

  deleteTemplate(id: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

  updateTemplate(
    id: string,
    data: TemplateRequestData
  ): Observable<CreateTemplateResponseData> {
    return this.http.patch<CreateTemplateResponseData>(
      `${this.apiUrl}/${id}`,
      data
    );
  }
}
